package com.iregained.site.components.sections.clinicians.styles

import com.iregained.site.theme.toSitePalette
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px

val TargetedMessagingContainerStyle = CssStyle.base {
    Modifier.fillMaxWidth().backgroundColor(colorMode.toSitePalette().nearBackground) // Alternating rhythm
}

val TargetedTabBarContainerStyle = CssStyle.base {
    Modifier.fillMaxWidth().margin(bottom = 48.px)
        .overflow { x(Overflow.Auto); y(Overflow.Hidden) } // Horizontal scroll on tiny mobile screens
}

val TargetedTabItemStyle = CssStyle {
    base {
        Modifier.cursor(Cursor.Pointer).padding(leftRight = 24.px, topBottom = 16.px)
            .borderBottom(3.px, LineStyle.Solid, Colors.Transparent) // Default state
            .transition(Transition.of("border-color", 200.ms))
    }
    hover {
        Modifier.borderBottom(3.px, LineStyle.Solid, colorMode.toSitePalette().brand.primarySoft)
    }
}

val TargetedGridStyle = CssStyle.base {
    Modifier.fillMaxWidth().maxWidth(1440.px).gap(40.px)
}

val TargetedContentColumnStyle = CssStyle.base {
    Modifier.fillMaxSize()
}

val TargetedHeadingStyle = CssStyle.base {
    Modifier.fontSize(28.px).fontWeight(FontWeight.Bold).color(colorMode.toSitePalette().custom.darkText)
        .margin(bottom = 16.px).lineHeight(1.2)
}

val TargetedDescStyle = CssStyle.base {
    Modifier.fontSize(16.px).color(colorMode.toSitePalette().custom.darkText.toRgb().copyf(alpha = 0.8f))
        .margin(bottom = 24.px).lineHeight(1.6)
}

val TargetedUlStyle = CssStyle.base { Modifier.padding(left = 20.px).margin(0.px).color(colorMode.toSitePalette().custom.darkText) }
val TargetedLiStyle = CssStyle.base { Modifier.margin(bottom = 8.px) }
val TargetedLiTextStyle = CssStyle.base {
    Modifier.fontSize(16.px).color(colorMode.toSitePalette().custom.darkText).fontWeight(FontWeight.Medium)
}

val TargetedImageBoxStyle = CssStyle.base {
    Modifier.fillMaxWidth().height(350.px).borderRadius(16.px).overflow(Overflow.Hidden)
        .boxShadow(0.px, 10.px, 30.px, color = Colors.Black.copy(alpha = 10)) // Adds depth to the dynamic images
}

val TargetedImageStyle = CssStyle.base {
    Modifier.fillMaxSize().objectFit(ObjectFit.Cover)
}